import React from 'react';
import { Helmet } from 'react-helmet';
import { Result } from 'antd';
import Translated from 'components/Translated';
import { getTranslated } from 'utils';

const Error404 = ({ locale }) => (
    <div className="gx-page-error-container">
        <Helmet>
            <title>{getTranslated('error.404.title', locale)}</title>
        </Helmet>

        <Result
            status="404"
            title={<Translated id="error.404.title" />}
            subTitle={<Translated id="error.404.description" />}
        />
    </div>
);

export default Error404;
